module.exports = __webpack_public_path__ + "img/nut-and-bolt.6e90db54.png";